const set_contractor_listing = (state, contractors) => {
  state.contractors = contractors;
};

const set_contractor = (state, contractor) => {
  state.contractor = contractor;
};

const set_contractor_region_dropdown = (
  state,
  contractorRegionDropdownOptions
) => {
  state.contractorRegionDropdownOptions = contractorRegionDropdownOptions;
};

const set_region_listing = (state, regions) => {
  state.regions = regions;
};

const set_region = (state, region) => {
  state.region = region;
};

const set_contacts_listing = (state, contacts) => {
  state.contacts = contacts;
};

const set_contact = (state, contact) => {
  state.contact = contact;
};

const delete_contact_by_id = (state, id) => {
  const i = state.contacts.map(item => item.id).indexOf(id);
  if (i !== -1) state.contacts.splice(i, 1);
};

export default {
  delete_contact_by_id,
  set_contact,
  set_contractor,
  set_contractor_listing,
  set_contractor_region_dropdown,
  set_region,
  set_region_listing,
  set_contacts_listing
};
